import { Component } from '@angular/core';
import { Observable, Subscription } from 'rxjs';
import * as fromStore from '../store';
import { select, Store } from '@ngrx/store';
import * as fromModels from '../models';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-job-status',
  templateUrl: './job-status.component.html'
})
export class JobStatusComponent {
  jobStatusResult$: Observable<fromStore.JobStatusDetailsState>;

  private _subscription: Subscription;
  private _jobStatus: fromModels.JobStatusResponse;

  constructor(private _store: Store<fromStore.JobState>, private route: ActivatedRoute, private router: Router) {}

  ngOnInit() {
    this.jobStatusResult$ = this._store.pipe(select(fromStore.getSelectedJobStatusDetailsState));

    this._subscription = this.jobStatusResult$.subscribe(s => {
      this._jobStatus = s.jobStatus;
    });

    // Subscribe to query params
    this.route.params.subscribe(params => {
      console.log('params: ', params);
      this._store.dispatch(new fromStore.LoadJobStatusDetails(params.id));
    });
  }

  onDestroy() {
    this._subscription.unsubscribe();
  }

  getJobStateName(state: number) {
    const jobState = fromModels.jobStates.find(js => js.value === state);
    return jobState ? jobState.key : 'Unknown';
  }

  getTriggerTypeName(triggerType: fromModels.TriggerType) {
    const triggerTypeValue = fromModels.triggerTypes.find(tt => tt.value === triggerType);
    return triggerTypeValue ? triggerTypeValue.key : 'Unknown';
  }

  getLogLevelName(logLevel: fromModels.LogLevel) {
    const logLevelValue = fromModels.logLevels.find(ll => ll.value === logLevel);
    return logLevelValue ? logLevelValue.key : 'Unknown';
  }

  splitMessage(message: string | undefined) {
    if (!message) return [];

    return message.split('\n');
  }
}
